import { createSelector } from 'reselect'

export const getElementsLoading = createSelector(
  state => Boolean(state && state.user && state.user.listSidebar && state.user.listSidebar.isLoading),
  isLoading => isLoading
)
